import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informaticopage',
  templateUrl: './informaticopage.component.html',
  styleUrls: ['./informaticopage.component.scss']
})
export class InformaticopageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
